<div class="container">


    <app-akit-header 
        title="editor" 
        [enableSubHeader]="false">
    </app-akit-header>

    <div *ngIf="initialised">
        <div *ngIf="isInteraction(); else exerciseElement">
            <app-akit-interaction-editor 
                [spec]="exerciseSpec" 
                [refId]="refId"
            ></app-akit-interaction-editor>
        </div>
        <ng-template #exerciseElement>
            <app-akit-exercise-editor 
                [spec]="exerciseSpec" 
            ></app-akit-exercise-editor>
        </ng-template>
    </div>
</div>
